var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { apiCreateUserRegistration } from '@/actions/RegistrationActions';
import { RegistrationView } from '@/components/pages/registration/RegistrationView';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { BAD_DIVISION_CLIENT, BAD_DIVISION_PROFESSIONAL, } from '@/utils/constants/api/responseCode';
import { parseQuery, parsedQueryToString, } from '@/utils/libs/query-string/parse';
import { REGISTRATION_TYPE_NORMAL } from '@/utils/resources/registration/registrationType';
import { REQUEST_DIVISION_CANDIDATE_CLIENT, REQUEST_DIVISION_CANDIDATE_PRO, } from '@/utils/resources/registration/requestDivision';
import { registrationCompleteClientPath, registrationCompleteConsultantPath, } from '@/utils/router/links';
/**
 * 新規登録
 * NOTE: submit 周りの処理を共通化する必要が出てきた場合 hooks 化してください
 */
export const RegistrationPage = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const history = useNavigate();
    /**
     * 完了画面 リダイレクト
     */
    const redirectToComplete = useCallback((requestDivision) => {
        const redirectPath = requestDivision === REQUEST_DIVISION_CANDIDATE_CLIENT.value
            ? registrationCompleteClientPath()
            : registrationCompleteConsultantPath();
        history.push(redirectPath);
    }, [history]);
    /**
     * 新規登録申請処理
     */
    const registration = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        const { ref, type } = parseQuery(search);
        const data = {
            json: Object.assign(Object.assign({}, values), { registrationType: parsedQueryToString(type) || REGISTRATION_TYPE_NORMAL, registrationUrl: parsedQueryToString(ref) || undefined }),
        };
        yield wrapDispatch(dispatch, apiCreateUserRegistration(data, {}));
        // 新規登録申請 成功時
        redirectToComplete(values.requestDivision);
    }), [dispatch, redirectToComplete, search]);
    /**
     * 新規登録申請失敗時の処理
     * @param errorObject
     */
    const registrationErrorCallback = useCallback(({ exception }) => {
        var _a, _b;
        const errorCode = (_b = (_a = exception === null || exception === void 0 ? void 0 : exception.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code;
        switch (errorCode) {
            // 許可ドメインエラー（企業）
            case BAD_DIVISION_CLIENT:
                return {
                    requestDivision: `コンサルタントの方は「${REQUEST_DIVISION_CANDIDATE_PRO.name.short}」をご選択ください`,
                };
            // 許可ドメインエラー（コンサル）
            case BAD_DIVISION_PROFESSIONAL:
                return {
                    requestDivision: `クライアントの方は「${REQUEST_DIVISION_CANDIDATE_CLIENT.name.short}」をご選択ください`,
                };
            default:
                return undefined;
        }
    }, []);
    return (_jsx(RegistrationView, { customErrorCallback: registrationErrorCallback, onSubmit: registration }));
};
